import React, { useEffect, useState } from "react";
import { parse_url } from "../../../../common/src";
import { PreloaderIcon } from "../Icons";
import * as widgetConstants from "../../../../cp/components/EventPage/Widgets/Registration/constants";

import "./style.scss";

const Preloader = () => {
    const request = parse_url(location.href);
    const [styles, setStyles] = useState({});

    useEffect(() => {
        setStyles({
            [widgetConstants.THEME_COLOR_DARK]: request?.getParameter('style[dark-color]') ?? '16161b',
            [widgetConstants.THEME_COLOR_LIGHT]: request?.getParameter('style[light-color]') ?? 'FFFFFF',
        })
    }, []);

    return (
        <div
            style={{backgroundColor: `#${styles[widgetConstants.THEME_COLOR_DARK]}`}}
            className="preloader"
        >
            <div className="preloader__icon">
                <PreloaderIcon color={`#${styles[widgetConstants.THEME_COLOR_LIGHT]}`} />
            </div>
        </div>
    );
};

export default Preloader;
